export const clearAuthStorage = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("is_non_tabler");
    localStorage.removeItem("member_type");
    localStorage.removeItem("company_division_id");
    localStorage.removeItem("company_id");
    localStorage.removeItem("userRole");
    localStorage.setItem("logIn", "false");
    localStorage.setItem("isPublicAccess", "true");
};
